import { forwardRef, memo } from "react";

export const SMSEditIcon = memo(
  forwardRef(function SMSEditIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M11.3241 20.0528H6.60574C3.16138 20.0528 1.17969 18.0711 1.17969 14.6268V8.02115C1.17969 4.57678 3.16138 2.59509 6.60574 2.59509H16.0424C19.4867 2.59509 21.4684 4.57678 21.4684 8.02115V10.8521C21.4684 11.239 21.1476 11.5599 20.7607 11.5599C20.3738 11.5599 20.0529 11.239 20.0529 10.8521V8.02115C20.0529 5.32228 18.7412 4.01059 16.0424 4.01059H6.60574C3.90687 4.01059 2.59518 5.32228 2.59518 8.02115V14.6268C2.59518 17.3257 3.90687 18.6373 6.60574 18.6373H11.3241C11.711 18.6373 12.0318 18.9582 12.0318 19.3451C12.0318 19.732 11.711 20.0528 11.3241 20.0528Z"
          fill={color}
        />
        <path
          d="M11.3231 12.1449C10.5305 12.1449 9.72836 11.8995 9.11498 11.3994L6.16131 9.04022C5.85934 8.79487 5.80272 8.35136 6.04808 8.04939C6.29343 7.74742 6.73694 7.70024 7.03891 7.93615L9.99258 10.2953C10.7098 10.8709 11.9271 10.8709 12.6443 10.2953L15.5979 7.93615C15.8999 7.6908 16.3434 7.73798 16.5888 8.04939C16.8341 8.35136 16.7869 8.80431 16.4755 9.04022L13.5219 11.3994C12.9179 11.8995 12.1158 12.1449 11.3231 12.1449Z"
          fill={color}
        />
        <path
          d="M14.9283 20.553C14.5697 20.553 14.23 20.4209 13.9847 20.1755C13.6921 19.883 13.56 19.4583 13.6261 19.0148L13.8054 17.7408C13.8525 17.4106 14.0507 17.0142 14.2866 16.7783L17.6272 13.4377C18.0801 12.9848 18.5237 12.7489 19.005 12.7017C19.59 12.6451 20.1751 12.8904 20.7224 13.4377C21.2697 13.9851 21.5151 14.5607 21.4585 15.1552C21.4113 15.627 21.1659 16.08 20.7224 16.533L17.3819 19.8735C17.1459 20.1094 16.7496 20.3076 16.4193 20.3548L15.1453 20.5341C15.0699 20.5435 15.0038 20.553 14.9283 20.553ZM19.1654 14.1078C19.1559 14.1078 19.1465 14.1078 19.1371 14.1078C19.0049 14.1172 18.8256 14.2399 18.6275 14.438L15.2869 17.7786C15.2586 17.8069 15.2114 17.9013 15.2114 17.939L15.0416 19.1186L16.2211 18.9487C16.2589 18.9393 16.3532 18.8921 16.3815 18.8638L19.7221 15.5233C19.9203 15.3157 20.043 15.1458 20.0524 15.0137C20.0713 14.8249 19.8825 14.5984 19.7221 14.438C19.5711 14.287 19.3541 14.1078 19.1654 14.1078Z"
          fill={color}
        />
        <path
          d="M19.7417 17.2218C19.6756 17.2218 19.6096 17.2124 19.5529 17.1935C18.3073 16.8444 17.3165 15.8535 16.9673 14.6079C16.8635 14.2304 17.0805 13.8435 17.458 13.7303C17.8355 13.6265 18.2224 13.8435 18.3262 14.221C18.5432 14.9948 19.1566 15.6081 19.9304 15.8252C20.3079 15.929 20.5249 16.3253 20.4211 16.7028C20.3362 17.0142 20.0531 17.2218 19.7417 17.2218Z"
          fill={color}
        />
      </svg>
    );
  }),
);

SMSEditIcon.displayName = "SMSEditIcon";